import { defineComponent, reactive, ref, watch, toRefs, onMounted, nextTick, onBeforeUnmount } from "vue";
import * as echarts from "echarts";
export default defineComponent({
  components: {},
  name: "",
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    title: {
      type: String,
      default: ''
    },
    chartData: {
      type: Object,
      default: () => {}
    },
    color: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    let myEcharts = ref(null);
    let myChart = null;
    const state = reactive({
      option: null
    });
    const methods = reactive({});
    const setOptions = ({
      legend,
      series,
      xaxis
    } = {}) => {
      let onlineRate = 0;
      let onlineItem = series.find(item => item.name == '在线');
      let total = series.reduce((total, item) => {
        return total + item.value;
      }, 0);
      onlineRate = (onlineItem.value / total * 100).toFixed(2) + '%';
      state.option = {
        color: props.color,
        title: {
          text: '在线率\n' + onlineRate,
          top: '36%',
          left: '48.6%',
          textAlign: 'center',
          textStyle: {
            color: '#fff',
            fontSize: 14,
            lineHeight: 20,
            fontWeight: 'bold'
          }
        },
        legend: {
          bottom: 0,
          textStyle: {
            color: '#fff'
          },
          data: props.chartData.legend || []
        },
        // polar: {},
        // angleAxis: {
        //     interval: 1,
        //     type: 'category',
        //     data: [],
        //     z: 10,
        //     axisLine: {
        //         show: false,
        //         lineStyle: {
        //             color: "#0B4A6B",
        //             width: 1,
        //             type: "solid"
        //         },
        //     },
        //     axisLabel: {
        //         interval: 0,
        //         show: true,
        //         color: "#0B4A6B",
        //         margin: 8,
        //         fontSize: 16
        //     },
        // },
        // radiusAxis: {
        //     axisLine: {
        //       show: false,
        //     },

        //     splitLine: {
        //       show:false
        //     }
        // },
        calculable: true,
        series: [{
          stack: 'a',
          type: 'pie',
          center: ['50%', '44%'],
          radius: ['40%', '70%'],
          // roseType: 'radius',
          legendHoverLink: false,
          zlevel: 10,
          label: {
            normal: {
              show: false,
              position: 'center',
              // 同步样式
              formatter: function (params) {
                return `{a|${params.seriesName}\n${params.value}}`;
              },
              rich: {
                a: {
                  color: '#fff',
                  fontSize: 14
                }
              }
            },
            emphasis: {
              show: true,
              // 同步样式
              formatter: function (params) {
                return `{a|${params.data.name}\n${params.data.value}}`;
              },
              rich: {
                a: {
                  color: '#fff',
                  fontSize: 14,
                  lineHeight: 20,
                  fontWeight: 'bold'
                }
              }
            }
          },
          labelLine: {
            show: false
          },
          data: props.chartData.series || []
        }
        //     {
        //     type: 'pie',
        //     center:['50%','44%'],
        //     radius: ["65%", "70%"],
        //     hoverAnimation: false,
        //     labelLine: {
        //         normal: {
        //             show: false,
        //             length: 30,
        //             length2: 55
        //         },
        //         emphasis: {
        //             show: false
        //         }
        //     },
        //     name: "",
        //     data: [{
        //         name: '',
        //         value: 0,
        //         itemStyle: {
        //             normal: {
        //                 color: "#0B4A6B"
        //             }
        //         }
        //     }]
        // }
        ]
      };
      myChart.on('mouseover', function () {
        myChart.setOption({
          title: {
            show: false
          }
        });
      });
      myChart.on('mouseout', function () {
        myChart.setOption({
          title: {
            show: true
          }
        });
      });
      myChart.setOption(state.option);
    };
    onMounted(() => {
      nextTick(() => {
        myChart = echarts.init(myEcharts.value);
        setOptions(props.chartData);
      });
    });
    window.addEventListener('resize', () => {
      myChart.resize();
    });
    onBeforeUnmount(() => {
      destroy();
    });
    const destroy = () => {
      if (!myChart) {
        return;
      }
      myChart.dispose(); //销毁
    };
    watch(() => props.chartData, () => {
      if (myChart) {
        myChart.clear();
      }
      setOptions(props.chartData);
    }, {
      deep: true
    });
    return {
      ...toRefs(state),
      ...toRefs(methods),
      setOptions,
      myEcharts,
      destroy
    };
  }
});